import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { forgotPassword } from "../actions/userAction";
import Message from "../components/Message";
import "../styles/signup.css";
import loginsvg from "../assets/login.svg";

const ForgotPassword = ({ history }) => {
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();

  const userLogin = useSelector((state) => state.userLogin);

  const { userInfo } = userLogin;

  const userForgotPass = useSelector((state) => state.userForgotPass);

  const { loading, error, response } = userForgotPass;

  useEffect(() => {
    if (userInfo && userInfo.role === "developer") {
      history.push("/developer/dashboard");
    } else if (userInfo && userInfo.role === "employer") {
      history.push("/employer/dashboard");
    } else if (userInfo && userInfo.role === "admin") {
      history.push("/admin/dashboard");
    } else {
      return;
    }
    // switch (userInfo.role) {
    //   case "developer":
    //     return history.push("/developer/dashboard")
    //   case "employer":
    //     return history.push("/employer/dashboard")
    //   default:
    //     return history.push("/admin/dashboard")
    //     break;
    // }
  }, [history, userInfo]);

  const handleSubmit = (e) => {
    e.preventDefault();

    dispatch(forgotPassword(email));
  };

  return (
    <div className="signup">
      {error && <Message variant="danger">{error}</Message>}
      {response && <Message variant="success">{response.message}</Message>}
      <div className="left">
        <div>
          <a className="logo" href="/">
            wedevelopers
          </a>
        </div>
        <div>
          <h4 className="font-subhead lh-small mt-2 mb-3">
            Discover the world's top developer and employer
          </h4>
        </div>
        <div className="mt-2">
          <img className="w-100" src={loginsvg} alt="sign up" />
        </div>
      </div>
      <div className="right">
        <div className="text-center logo-sm mt-2">
          <a className="logo" href="/">
            wedevelopers
          </a>
        </div>
        <div className="form-wrapper">
          <h3 className="lh-small font-subhead mb-3">
            Enter your Email to reset password
          </h3>
          <form onSubmit={handleSubmit} className="w-100">
            <div className="mb-1">
              <label>Email</label>
              <div className="input">
                <i class="far fa-envelope"></i>
                <input
                  type="email"
                  value={email}
                  placeholder="Enter your email"
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="my-2">
              <button className="d-flex justify-content-center" type="submit">
                {loading ? <div className="spinner"></div> : "SUBMIT"}
              </button>
            </div>
          </form>
          <p className="text-center mb-1">
            <Link to="/login">Go back to login</Link>
          </p>
          <p className="text-center mb-1">
            Don't have an account? <Link to="/employer/signup">Signup</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
